import axios from "axios";
import firebase from "../services/firebase";

const baseURL = process.env.REACT_APP_API_HOST;

const AxiosInstance = () =>
  axios.create({
    baseURL,
    timeout: 60000,
    headers: {
      "Content-Type": "application/json",
    },
  });

const axiosInstance = AxiosInstance();
axiosInstance.interceptors.request.use(async (config) => {
  const user = firebase.currentUser();
  const token = user && (await user.getIdToken());
  config.headers.Authorization = `Bearer ${token}`;

  return config;
});

export default axiosInstance;
